import { ConnectorDump, _Connector } from "./Node";
import { Point } from "./Point";
import { v4 as uuidv4 } from "uuid";


/**
 * Saved connection information.
 */
export interface ConnectionDump {
    id: string;
    a: ConnectorDump;
    b: ConnectorDump;
}


/**
 * Connections connect connectors of nodes.
 */
export class Connection {
    id: string;
    a: _Connector;
    b: _Connector;
    ctx: CanvasRenderingContext2D;
    from: Point;
    fromContr: Point;
    to: Point;
    toContr: Point;
    constructor(a: _Connector, b: _Connector, context: CanvasRenderingContext2D) {
        this.id = uuidv4();
        this.a = a;
        this.b = b;
        this.ctx = context;
        this.update();
    }
    /**
     * update
     */
    public update() {
        this.from = { x: this.a.xPos, y: this.a.yPos };
        this.to = { x: this.b.xPos, y: this.b.yPos };
        let offset = 80;
        let m = 1;
        if (this.a.isInput) {
            m = -1;
        }
        this.fromContr = {
            x: this.a.xPos + Math.min(offset, Math.abs(this.a.xPos - this.b.xPos)) * m,
            y: this.a.yPos
        };
        m = 1;
        if (this.b.isInput) {
            m = -1;
        }
        this.toContr = {
            x: this.b.xPos + Math.min(offset, Math.abs(this.a.xPos - this.b.xPos)) * m,
            y: this.b.yPos
        };
    }
    /**
     * draw
     */
    public draw() {
        this.ctx.lineWidth = 5;
        this.ctx.strokeStyle = this.a.color;
        this.ctx.beginPath();
        this.ctx.moveTo(this.from.x, this.from.y);
        this.ctx.bezierCurveTo(this.fromContr.x, this.fromContr.y, this.toContr.x, this.toContr.y, this.to.x, this.to.y);
        this.ctx.stroke();
    }

    /**
     * Disconnect the connectors that are connected by this connection.
     */
    public dissolve() {
        this.a.disconnectFrom(this.b);
        this.b.disconnectFrom(this.a);
        if (this.a.isInput) {
            this.a.parentNode?.calculateValues();
        } else {
            this.b.parentNode?.calculateValues();
        }
    }

    /**
     * save the relevant connection information as a JS object.
     */
    public save(): ConnectionDump {
        return {
            id: this.id,
            a: this.a.save(),
            b: this.b.save()
        }
    }
}
